export default __webpack_public_path__ + "static/media/foodimg.be1ccfac.svg";